import uniqBy from 'lodash/uniqBy';
import cloneDeep from 'lodash/cloneDeep';

function saveContact(groups, newContact, exists = true, categoryChanged = false) {
  if (categoryChanged) {
    exists = false;
  }
  const newGroups = groups.map((category) => {
    category.entries = (
      categoryChanged
        ? category.entries.filter((contact) => !!newContact.id && contact.id !== newContact.id)
        : category.entries.map((contact) => (!!newContact.id && contact.id === newContact.id ? newContact : contact))
    ).concat(!exists && category.name === newContact.fields[Object.keys(newContact.fields)[0]].category ? [newContact] : []);
    return category;
  });
  return newGroups;
}

function removeContact(groups, removedContact, removedIndex) {
  return groups.map((category) => {
    category.entries = category.entries.filter(
      (contact, index) => (!!removedContact.id && contact.id !== removedContact.id) || removedIndex !== index
    );
    return category;
  });
}

function removeCategory(groups, removedCategory) {
  return groups.filter((category) => category.name !== removedCategory.name);
}

function saveCategory(groups, newCategory, oldCategoryName) {
  return uniqBy(
    groups
      .map((category) => {
        if (oldCategoryName === category.name) {
          category = newCategory;
          category.entries = category.entries.map((entry) => {
            entry.fields.category = category.name;
            return entry;
          });
        }
        return category;
      })
      .concat(
        !oldCategoryName
          ? [
              {
                name: Math.floor(Date.now() / 1000).toString(),
                fields: cloneDeep(newCategory.fields),
                entries: [],
                properties: {
                  editable: true,
                },
              },
            ]
          : []
      ),
    'name'
  );
}

export default {
  saveContact,
  saveCategory,
  removeCategory,
  removeContact,
};



// WEBPACK FOOTER //
// ./src/modules/contact/helpers/contact-helpers.js